import React, { useState } from 'react';
// ui
import Icon from '@material-ui/core/Icon';

const ModalSetButton = ({
    button,
    changeBtn,
    buttonIdx,
    isOverflowModal,
    isBottomModal,
    isQuick,
    delBtn,
    delAfterClose,
    fixedRatio,
    buttonsLength,
}) => {
    // state
    const [selectType, SetSelectType] = useState(button.action);

    // 버튼 obj
    let buttonObj = button;
    // 버튼명 maxLength
    const buttonLabelMax = fixedRatio && buttonsLength > 1 ? 8 : 14;
    // 버튼명 글자수
    const changedLabelValue = buttonObj.label
        ? buttonObj.label.substring(0, buttonLabelMax)
        : '';
    // 메세지 글자수
    const changedMsgValue = buttonObj.messageText
        ? buttonObj.messageText.substring(0, 14)
        : '';
    // 폰번호 글자수
    const changedPhoneValue = buttonObj.phoneNumber
        ? buttonObj.phoneNumber.substring(0, 20)
        : '';

    // 버튼명 전체 선택
    const handleFocusInp = (e) => {
        e.target.select();
    };

    // 버튼명 변경
    const handleChangeName = (e) => {
        let value = e.target.value;
        const valueLength = e.target.value.length;
        const maxlength = e.target.getAttribute('maxlength');
        if (valueLength > maxlength) {
            value = value.substr(0, maxlength);
        }

        buttonObj.label = value;

        buttonObj.label =
            buttonObj.label === '' ? '버튼 설정' : buttonObj.label;

        changeBtn(buttonObj, buttonIdx);
    };

    // 버튼 액션 변경
    const handleChangeInp = (e) => {
        let actionValue = e.target.name;
        let currentValue = e.target.value;

        if (actionValue === 'phoneNumber' || actionValue === 'messageText') {
            if (currentValue.length > e.target.maxLength) {
                currentValue = currentValue.slice(0, e.target.maxLength);
            }
        }

        // 전화번호 숫자만 받음
        if (actionValue === 'phoneNumber') {
            currentValue = currentValue.replace(/[^0-9]/g, '');
        }

        buttonObj = {
            label: buttonObj.label,
            action: selectType,
            [actionValue]: currentValue,
        };
        changeBtn(buttonObj, buttonIdx);
    };

    // 버튼 삭제
    const handleDelBtn = () => {
        delBtn(buttonIdx);
        delAfterClose(false);
    };

    // select 변경 이벤트
    const changeSelect = (e) => {
        let selectedType = e.target.value;
        SetSelectType(selectedType);
        buttonObj = {
            label: buttonObj.label,
            action: e.target.value,
        };
        switch (selectedType) {
            case 'webLink':
                buttonObj.webLinkUrl = '';
                break;
            case 'osLink':
                buttonObj.osLink = {};
                break;
            case 'message':
                buttonObj.messageText = '';
                break;
            case 'phone':
                buttonObj.phoneNumber = '';
                break;
            case 'block':
                buttonObj.blockId = '';
                //buttonObj.messageText = '';
                break;
            default:
                console.log('no select!');
        }
        changeBtn(buttonObj, buttonIdx);
    };

    // OsLink 설정
    const handleChangeOsInp = (e) => {
        let osLinkType = e.target.name;
        let osLinkValue = e.target.value;
        let newOsLink = {
            ...buttonObj.osLink,
            [osLinkType]: osLinkValue,
        };
        buttonObj = {
            label: buttonObj.label,
            action: 'osLink',
            osLink: newOsLink,
        };
        changeBtn(buttonObj, buttonIdx);
    };

    return (
        <div
            className={`dialog-wrap button ${isOverflowModal ? 'left' : ''} ${
                isBottomModal ? 'bottom' : ''
            }`}
        >
            <h4>버튼 설정</h4>
            <button type="button" onClick={handleDelBtn}>
                <Icon>delete_outline</Icon>
            </button>
            <form className="dialog-form">
                {/* 버튼명 */}
                <div>
                    <h5>
                        버튼명 <span>*</span>
                    </h5>
                    <input
                        type="text"
                        className="width100"
                        placeholder="버튼명을 입력해주세요."
                        value={
                            changedLabelValue !== '버튼 설정'
                                ? changedLabelValue
                                : ''
                        }
                        onChange={handleChangeName}
                        onFocus={handleFocusInp}
                        maxLength={`${
                            fixedRatio && buttonsLength > 1 ? 8 : 14
                        }`}
                    />
                    <span>
                        <span>
                            {changedLabelValue !== '버튼 설정'
                                ? changedLabelValue.length
                                : 0}
                        </span>
                        /{fixedRatio && buttonsLength > 1 ? 8 : 14}
                    </span>
                </div>
                {/* 버튼 기능 */}
                <div>
                    <h5>
                        버튼 기능 <span>*</span>
                    </h5>
                    <select onChange={changeSelect} value={selectType}>
                        {!isQuick && <option value="webLink">weblink</option>}
                        {!isQuick && <option value="osLink">oslink</option>}
                        <option value="message">메시지전송</option>
                        {!isQuick && <option value="phone">전화</option>}
                        <option value="block">블록연결</option>
                    </select>
                    {(() => {
                        if (selectType === 'webLink')
                            return (
                                <input
                                    type="text"
                                    className="width100"
                                    placeholder="https://"
                                    onChange={handleChangeInp}
                                    value={buttonObj.webLinkUrl || ''}
                                    name="webLinkUrl"
                                />
                            );
                        if (selectType === 'osLink')
                            return (
                                <ul className="dialog-form-link-list">
                                    <li>
                                        <label htmlFor="dg-img-link-web">
                                            web link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-web"
                                            placeholder="https://"
                                            name="web"
                                            onChange={handleChangeOsInp}
                                            value={buttonObj.osLink.web || ''}
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-pc">
                                            pc link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-pc"
                                            placeholder="https://"
                                            name="pc"
                                            onChange={handleChangeOsInp}
                                            value={buttonObj.osLink.pc || ''}
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-mac">
                                            mac link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-mac"
                                            placeholder="https://"
                                            name="mac"
                                            onChange={handleChangeOsInp}
                                            value={buttonObj.osLink.mac || ''}
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-win">
                                            win link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-win"
                                            placeholder="https://"
                                            onChange={handleChangeOsInp}
                                            value={buttonObj.osLink.win || ''}
                                            name="win"
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-mb">
                                            mobile link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-mb"
                                            placeholder="https://"
                                            onChange={handleChangeOsInp}
                                            value={
                                                buttonObj.osLink.mobile || ''
                                            }
                                            name="mobile"
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-ios">
                                            iOS link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-ios"
                                            onChange={handleChangeOsInp}
                                            value={buttonObj.osLink.ios || ''}
                                            name="ios"
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-and">
                                            android link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-and"
                                            onChange={handleChangeOsInp}
                                            value={
                                                buttonObj.osLink.android || ''
                                            }
                                            name="android"
                                        />
                                    </li>
                                </ul>
                            );
                        if (selectType === 'message')
                            return (
                                <>
                                    <input
                                        type="text"
                                        className="width100"
                                        placeholder="채팅방에 전송할 메세지 입력"
                                        onChange={handleChangeInp}
                                        value={changedMsgValue}
                                        name="messageText"
                                        maxLength="14"
                                    />
                                    <span>
                                        <span>{changedMsgValue.length}</span>
                                        /14
                                    </span>
                                </>
                            );
                        if (selectType === 'phone')
                            return (
                                <>
                                    <input
                                        type="text"
                                        className="width100"
                                        placeholder="전화번호 입력"
                                        onChange={handleChangeInp}
                                        value={changedPhoneValue}
                                        name="phoneNumber"
                                        maxLength="20"
                                    />
                                    <span>
                                        <span>{changedPhoneValue.length}</span>
                                        /20
                                    </span>
                                </>
                            );
                        if (selectType === 'block')
                            return (
                                <input
                                    type="text"
                                    className="width100"
                                    placeholder="연결할 블록 ID 입력"
                                    onChange={handleChangeInp}
                                    value={buttonObj.blockId}
                                    name="blockId"
                                />
                            );
                    })()}
                </div>
            </form>
        </div>
    );
};

export default ModalSetButton;
